import AddDocComponentCommand from "../addComponentCommandBase/addDocComponentCommand";

class AddDocQuoteTableCommand extends AddDocComponentCommand {
  constructor(componentData) {
    super(componentData);
    this.componentData = componentData;
  }

  redo() {
    super.redo();
    this.componentData.addDealTableTab();
  }

  execute() {
    if (this.isRedo) {
      this.redo();
    } else {
      // 1.
      super.prepareLayout();
      // 2.
      const activeEditorPayload = super.getActiveEditorPayload();
      // 3.
      super.updateRedux(activeEditorPayload);
      const componentPayload = super.getComponentPayload();

      super.saveToDatabase(componentPayload).then(() => {
        this.componentData.addDealTableTab();
      });
    }
  }

  undo() {
    super.undo();
  }
}

export default AddDocQuoteTableCommand;
